import { Comune } from './comune';
import { Cap } from './cap';

export class Anagrafica {
  nome: string;
  cognome: string;
  mail: string;
  telefono: string;
  cellulare: string;
  codiceFiscale: string;
  pIva: string;
  comune: Comune;
  idCap: number;
  cap: Cap;
  indirizzo: string;
  denominazione: string;
  idComuneCameraCommercio: number;
  comuneCameraCommercio: Comune;
  vendo: boolean;
  acquisto: boolean;
  offroAffitto: boolean;
  cercoAffitto: boolean;
  dichiarazioneResponsabilitaPotereAcquisto: boolean;
  potereAcquisto: boolean;
  polizzaAffitto: boolean;
  mutuo: boolean;
  condizioniGenerali: boolean;
  condizioniGeneraliClausole: boolean;
  informativaPrivacy: boolean;
  informativaPrivacyMutuo: boolean;
  id: number;
  codiceDestinatario: string;
  pec: string;

  constructor(){
    this.comune = new Comune();
    this.cap = new Cap();
    this.comuneCameraCommercio = new Comune();
    this.condizioniGenerali = false;
    this.condizioniGeneraliClausole = false;
    this.informativaPrivacy = false;
  }
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/anagrafica.ts